import React from 'react'

const SvgSmileFaceOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.069 14.984c.922-.034 1.788-.448 2.28-1.052a1 1 0 111.551 1.262c-.902 1.11-2.34 1.736-3.757 1.789-1.437.053-2.97-.483-3.972-1.848a1 1 0 011.612-1.184c.54.736 1.384 1.067 2.286 1.033z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 20a8 8 0 100-16 8 8 0 000 16zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z'
    />
    <path d='M10 10.688a1 1 0 11-2 0 1 1 0 012 0zM16 10.688a1 1 0 11-2 0 1 1 0 012 0z' />
  </svg>
)

export default SvgSmileFaceOutline
